import { gql } from "@apollo/client";

import { THREAD_ACTION_FIELDS } from "./threadAction";

export const THREAD_FIELDS_FOR_LIST = gql`
  fragment ThreadFieldsForList on ThreadListResult {
    contactFirstName
    contactLastName
    createdAt
    fromPhoneNumber
    id
    lastMessageAt
    needsTexterResponse
    isOptedOut
    defaultContextCampaign {
      id
      name
    }
    toPhoneNumber
    updatedAt
    currentInbox {
      id
      name
      type
    }
    pinnedToInbox {
      id
      name
    }
  }
`;

export const SEARCH_THREADS = gql`
  ${THREAD_FIELDS_FOR_LIST}
  query searchThreads($input: SearchThreadsInput!) {
    searchThreads(input: $input) {
      ...ThreadFieldsForList
    }
  }
`;

export const SEARCH_THREADS_COUNT = gql`
  query searchThreadsCount($input: SearchThreadsCountInput!) {
    searchThreadsCount(input: $input) {
      totalCount
      totalCountOverLimit
    }
  }
`;

export const THREAD_FIELDS_FOR_DETAIL = gql`
  ${THREAD_ACTION_FIELDS}
  fragment ThreadFieldsForDetail on ThreadDetail {
    contactFirstName
    contactLastName
    createdAt
    fromPhoneNumber
    id
    lastMessageAt
    needsTexterResponse
    isOptedOut
    ownedByCampaign {
      id
      name
    }
    toPhoneNumber
    fromOwnedPhoneNumber {
      id
      shortCodeConfig {
        optInMessage
        optOutMessage
      }
      messageClass
    }
    subscriber {
      id
      firstName
      lastName
      optOuts {
        id
        deletedAt
      }
    }
    updatedAt
    messages {
      direction
      id
      mediaAttachments {
        mimeType
        url
      }
      messageType
      provider
      providerErrorCode
      providerId
      segments
      status
      text
      threadOrderTime
      campaignId
      campaignShortId
      campaignName
      campaignContactId
      createdByUserId
      createdByUserFullName
      isInitialOutboundForCampaign
      shortenedLinks {
        shortUrl
        targetUrl
      }
    }
    pinnedToInbox {
      id
      name
    }
    threadActions {
      ... on ThreadAction {
        ...ThreadActionFields
      }
      ... on ApplyCampaignTagsThreadAction {
        ...ThreadActionFields
        actionData {
          tags {
            id
            name
            group {
              id
              name
            }
          }
        }
      }
      ... on RemoveCampaignTagsThreadAction {
        ...ThreadActionFields
        actionData {
          tags {
            id
            name
            group {
              id
              name
            }
          }
        }
      }
      ... on EscalateThreadAction {
        ...ThreadActionFields
        actionData {
          escalationInbox {
            id
            name
          }
        }
      }
      ... on DeescalateThreadAction {
        ...ThreadActionFields
        actionData {
          escalationInbox {
            id
            name
          }
        }
      }
      ... on MoveEscalationThreadAction {
        ...ThreadActionFields
        actionData {
          fromEscalationInbox {
            id
            name
          }
          toEscalationInbox {
            id
            name
          }
        }
      }
      ... on MoveInboxThreadAction {
        ...ThreadActionFields
        actionData {
          fromInbox {
            id
            name
          }
          toInbox {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_THREAD = gql`
  ${THREAD_FIELDS_FOR_DETAIL}
  query getThread($input: GetThreadInput!) {
    getThread(input: $input) {
      ...ThreadFieldsForDetail
    }
  }
`;

export const MARK_THREAD_NEEDS_RESPONSE = gql`
  ${THREAD_FIELDS_FOR_DETAIL}

  mutation markThreadNeedsResponse($input: MarkThreadNeedsResponseInput!) {
    markThreadNeedsResponse(input: $input) {
      ...ThreadFieldsForDetail
    }
  }
`;

export const MARK_THREAD_NOT_NEEDS_RESPONSE = gql`
  ${THREAD_FIELDS_FOR_DETAIL}

  mutation markThreadNotNeedsResponse(
    $input: MarkThreadNotNeedsResponseInput!
  ) {
    markThreadNotNeedsResponse(input: $input) {
      ...ThreadFieldsForDetail
    }
  }
`;

export const MARK_THREADS_NOT_NEEDS_RESPONSE_BULK = gql`
  mutation markThreadsNotNeedsResponseBulk(
    $input: MarkThreadsNotNeedsResponseBulkInput!
  ) {
    markThreadsNotNeedsResponseBulk(input: $input) {
      id
    }
  }
`;

export const MARK_THREAD_OPTED_OUT = gql`
  ${THREAD_FIELDS_FOR_DETAIL}

  mutation markThreadOptedOut($input: MarkThreadOptedOutInput!) {
    markThreadOptedOut(input: $input) {
      ...ThreadFieldsForDetail
    }
  }
`;

export const MARK_THREADS_OPTED_OUT_BULK = gql`
  mutation markThreadsOptedOutBulk($input: MarkThreadsOptedOutBulkInput!) {
    markThreadsOptedOutBulk(input: $input) {
      id
    }
  }
`;

export const SEND_MESSAGE_TO_THREAD = gql`
  ${THREAD_FIELDS_FOR_DETAIL}
  mutation sendMessageToThread($input: SendMessageToThreadInput!) {
    sendMessageToThread(input: $input) {
      ...ThreadFieldsForDetail
    }
  }
`;

export const ESCALATE_THREAD = gql`
  ${THREAD_FIELDS_FOR_DETAIL}
  mutation escalateThread($input: EscalateThreadInput!) {
    escalateThread(input: $input) {
      ...ThreadFieldsForDetail
    }
  }
`;

export const DEESCALATE_THREAD = gql`
  ${THREAD_FIELDS_FOR_DETAIL}
  mutation deescalateThread($input: DeescalateThreadInput!) {
    deescalateThread(input: $input) {
      ...ThreadFieldsForDetail
    }
  }
`;

export const MOVE_THREADS_TO_INBOX = gql`
  mutation moveThreadsToInbox($input: MoveThreadsToInboxInput!) {
    moveThreadsToInbox(input: $input) {
      success
    }
  }
`;

export const DEESCALATE_THREADS_BULK = gql`
  mutation deescalateThreads($input: DeescalateThreadsInput!) {
    deescalateThreads(input: $input) {
      success
    }
  }
`;
